import { Form } from './form';
import { DiscountView } from '../view/discount-view';
import { Config } from '../config';
import { DiscountProvider } from '../providers/discount-provider';
import { FormTypes } from './form-types';
import { Discount } from '../config/discount';
import { Translations } from '../config/translations';
import { Order } from '../config/order';
import { Util } from '../config/utils';

declare const process: any;

export class DiscountForm extends Form {

    view: DiscountView = new DiscountView();
    type = FormTypes.Discount;
    provider: DiscountProvider = new DiscountProvider();
    coupon: any = {};
    currentTotalAmount = 0;
    discountType: any;
    isTotalClearedByDiscount = false;
    discounts: Discount[] = [];
    formId: any;
    selectedSubs: any[] = [];
    discountUrl: string | null | undefined;
    

    constructor(step: number | null = null) {
        super();
        this.step = step;
    }

    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
        this.formId = config.formId;
        this.discountUrl = Util.getUrlParameter('discount', window.location.href);

        return Promise.resolve();
    }

    async render() {
        this.view.renderDiscountCodeForm(this.getDiscount.bind(this));

        if (this.discountUrl && this.discountUrl.length) {
            this.view.assignDiscountFromUrl(this.discountUrl);
        }

        if (this.step) {
            this.hideForm();
        }
        
        return Promise.resolve();
    }

    submit(order: Order) {
        // const submissionData: any = {
        //     paymentType: this.config.settings.paymentType
        // };
        // if (this.currentTotalAmount <= 0) {
        //     submissionData.paymentType = ProductType.NO_PAYMENT;
        // }

        //this.config.settings.discount ? submissionData.discountId = this.coupon.id : submissionData.couponId = this.coupon.id;
        return Promise.resolve(order);
    }

    resetDiscount() {
        this.discounts = [];
        this.clearDiscountInfo();
    }

    generateProviderConfig(prodType: string) {
        const providerConfig = {
            discountUrl: '',
            host: process.env.DISCOUNT_URL,
            portalId: this.config.user.portalId,
            accountId: this.config.forms.stripe ? this.config.forms.stripe.accountId : null
        };
        if (prodType === 'discount') {
            providerConfig.discountUrl = '&code=';
            this.discountType = 'discountId';
        }
        if (prodType === 'stripeDiscount') {
            providerConfig.discountUrl = '&couponId=';
            this.discountType = 'couponId';
        }
        return providerConfig;
    }

    private async getDiscount() {
        await this.clearDiscountInfo();
        const codeField = document.querySelector('#df-discount-code') as HTMLInputElement;
        const code = codeField.value;
        if (code) {
            const discTypes = this.provider.getDiscountType(this.config.products);
            if (discTypes.length === 0) {
                return Promise.reject();
            }

            this.discounts = [];

            const reqs = discTypes.map(async (item: any) => {
                const providerConfig = this.generateProviderConfig(item);
                return await this.provider.getDiscount(providerConfig, code, this.formId, this.selectedSubs.map((x: any) => x.subscriptionPlanId || x.id))
                    .then((response) => {
                        switch (response.type) {
                            case 'discountUrl':
                                this.handleDiscount(response);
                                break;
                            case 'couponUrl':
                                this.handleSubscriptionDiscount(response);
                                break;
                            default:
                                break;
                        }
                    })
                    .catch((error: any) => {
                        this.config.settings.reqDiscountCounter = this.config.settings.reqDiscountCounter ? this.config.settings.reqDiscountCounter + 1 : 1;
                        if (discTypes.length > 1) {
                            return { error: error.errorMessage || Translations.DISCOUNT_NOT_FOUND };
                        }
                        const errorMessage = Translations.DISCOUNT_NOT_FOUND;
                        this.view.setDiscountErrorResult(errorMessage);
                        this.logger.log(error || errorMessage);
                        this.triggerEvent('amountChange');
                    });
            }, this);
            Promise.all(reqs).then((data: any) => {
                if (data[0] && data[1]) {
                    if (data[0].error && data[1].error) {
                        const errorMessage = Translations.DISCOUNT_FAILED;
                        this.view.setDiscountErrorResult(errorMessage);
                        this.logger.log(errorMessage);
                    }
                }
            });
        } else {
            this.config.settings.couponId = {};
            this.config.settings.discountId = {};
            this.coupon = {
                amountOff: 0,
                currency: null,
                id: null,
                percentOff: 0
            };
        }
    }

    handleDiscount = (response: any) => {
        const discount: Discount = Object.assign(new Discount(), response.response);
        discount.type = response.type;
        this.discounts.push(discount);
        this.view.setDiscountSuccessResult(Translations.DISCOUNT_APPLIED);
        this.triggerEvent('amountChange');
    }

    handleSubscriptionDiscount = (response: any) => {
        if (response.response.stripeCoupon) {
            const stripeCouponDiscount: Discount = Object.assign(new Discount(), response.response.stripeCoupon);
            stripeCouponDiscount.type = response.type;
            this.discounts.push(stripeCouponDiscount);
            this.view.setDiscountSuccessResult(Translations.DISCOUNT_APPLIED);
            this.triggerEvent('amountChange');
        }
        if (response.response.discount) {
            const discount: Discount = Object.assign(new Discount(), response.response.discount);
            discount.type = response.type;
            this.discounts.push(discount);
            this.view.setDiscountSuccessResult(Translations.DISCOUNT_APPLIED);
            this.view.showDiscountTrialDays(`${response.response.discount.trialDays} ${Translations.DISCOUNT_TRIAL_DAYS_APPLIED}`);
        }
    }

    private async clearDiscountInfo() {
        this.view.setDiscountSuccessResult('');
        this.view.hideDiscountTrialDays();
    }

    showForm() {
        this.view.showForm();
    }

    hideForm() {
        this.view.hideForm();
    }

}
